import React, { useState } from "react";

const SpecialTests = ({ stepData, onSubmit }: any) => {
  const schema = stepData.ui_schema;
  const config = schema.config;

  const [activePart, setActivePart] = useState(
    config.body_parts[0]
  );

  // ✅ values: bodyPart → testId → fields
  const [values, setValues] = useState<any>({});

  const template = config.templates.TRI_INPUT; // default template

  const handleChange = (
    part: string,
    testId: string,
    key: string,
    value: any
  ) => {
    setValues((prev: any) => ({
      ...prev,
      [part]: {
        ...prev[part],
        [testId]: {
          ...prev[part]?.[testId],
          [key]: value,
        },
      },
    }));
  };

  // ✅ prepare payload
  const handleSubmit = (endpoint: string) => {
    const payload: any[] = [];

    Object.keys(values).forEach((part) => {
      Object.keys(values[part]).forEach((testId) => {
        payload.push({
          // body_part: part,
          test_id: testId,
          values: values[part][testId],
        });
      });
    });

    onSubmit(endpoint, payload);
  };

  return (
    <div>
      <h6>{schema.title}</h6>

      <div className="row">

        {/* ✅ LEFT: BODY PARTS */}
        <div className="col-4">
          <ul className="list-group">
            {config.body_parts.map((part: string) => (
              <li
                key={part}
                className={`list-group-item ${activePart === part ? "active" : ""
                  }`}
                style={{ cursor: "pointer" }}
                onClick={() => setActivePart(part)}
              >
                {part}
              </li>
            ))}
          </ul>
        </div>

        {/* ✅ RIGHT: TESTS */}
        <div className="col-8">
          {(config.tests_by_part[activePart] || []).map(
            (test: any) => (
              <div key={test.id} className="mb-3">
                <h6>{test.text}</h6>

                <div className="row">
                  {(config.templates[test.uiType] ||[]).map((field: any) => (
                    <div className="col-4" key={field.key}>
                      <label>{field.label}</label>
                      <input
                        type={
                          field.type === "NUMBER"
                            ? "number"
                            : "text"
                        }
                        className="form-control"
                        value={
                          values[activePart]?.[test.id]?.[
                          field.key
                          ] || ""
                        }
                        onChange={(e) =>
                          handleChange(
                            activePart,
                            test.id,
                            field.key,
                            e.target.value
                          )
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
            )
          )}
        </div>
      </div>

      {/* ✅ Buttons */}
      <div className="d-flex justify-content-end mt-3">
        {schema.buttons.map((btn: any, i: number) => {
          if (btn.action === "FINALIZE") {
            return (
              <button
                key={i}
                type="button"
                className="btn btn-success"
                onClick={() => handleSubmit(btn.endpoint)}
              >
                {btn.label}
              </button>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
};

export default SpecialTests;